import _ from "lodash";

const GroupFactory = function ($q, $http, $window) {
    const factory = {};

    factory.isSubjectToFEVA = function (groupId) {
        const deferred = $q.defer();
        let url = "/participant-web-services/rest/group/";

        if (groupId === null) {
            //Checks all the accounts to see if any is subject to FEVA
            url = url + "isSubjectToFEVA";
        } else {
            //Checks all the accounts to see if any is subject to FEVA
            url = url + "isGroupSubjectToFEVA?gaId=" + groupId;
        }
        $http
            .get(__baseApiUrl__ + url)
            .success(function (data, status, headers, config) {
                deferred.resolve(data);
            })
            .error(function (data, status, headers, config) {
                deferred.reject(headers("exceptionMessage"));
            });

        return deferred.promise;
    };

    return factory;
};

GroupFactory.$inject = ["$q", "$http", "$window"];
export default GroupFactory;
